import {
  AssemblyRow,
  BoMItemRow,
  MaterialHeaderRow,
  PartTypeRow,
  RoutingHeaderRow,
} from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'

export function bomItemSelector(
  state: RootAppState,
  bomItemId: string,
  preferTreeView?: boolean
): AssemblyRow | PartTypeRow | MaterialHeaderRow | RoutingHeaderRow {
  let bomItem: BoMItemRow

  if (
    preferTreeView ||
    state.project.currentView === ProjectViews.AssemblyHierarchy
  ) {
    bomItem =
      (state.project?.treeView && state.project?.treeView[bomItemId]) ||
      (state.project?.flatView && state.project?.flatView[bomItemId])
  } else {
    bomItem =
      (state.project?.flatView && state.project?.flatView[bomItemId]) ||
      (state.project?.treeView && state.project?.treeView[bomItemId])
  }

  switch (bomItem?.type) {
    case 'AssemblyHeader': {
      return { ...bomItem.assembly, ...bomItem, type: 'Assembly' }
    }
    default:
      return bomItem
  }
}
